/* unplugin-vue-components disabled */import script from "./OddsHistoryTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OddsHistoryTable.vue?vue&type=script&setup=true&lang=js"

import "./OddsHistoryTable.vue?vue&type=style&index=0&id=cbb99884&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbb99884"]])

export default __exports__